import React from 'react';

import Power from 'material-ui/svg-icons/notification/power';
import Home from 'material-ui/svg-icons/action/home';
import generator from 'assets/images/generator.svg';

export default {
  steps: [
    {
      id: 1,
      title: '1. Your Home',
      icon: props => <Home {...props} />,
    },
    {
      id: 2,
      title: '2. Your Needs',
      icon: props => <Power {...props} />,
    },
    {
      id: 3,
      title: '3. Recommendation',
      icon: props => <img {...props} src={generator} alt="Generator icon" role="presentation" />,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/views/Home/configs/steps-config.js